import { StorageTankIcon } from './StorageTankIcon';

/**
 * author: Google
 * id 2C19B9EA-AB7C-401A-B84F-A0DCD2336BBE
 * name storage-tank
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/storage-tank.svg
 * tags
 */
export const GasTankIcon = StorageTankIcon;
export default GasTankIcon